function KuschelnPage() {

    return (
        <>

            <div className="intro">

                <h1>
                    Achtsames Kuscheln im Sarganserland
                </h1>

                <p>
                    Kuscheln ist ein Grundbedürfnis nach Nähe,
                    Berührung und Geborgenheit.
                </p>

            </div>


            <main className="text-inhalt">

                <p>
                    Manchmal hat man einfach das Bedürfnis nach Nähe
                    und Geborgenheit.
                </p>

                <p>
                    Gerne gebe ich Dir den Moment mit gegenseitiger
                    sanfter Berührung und Streicheln oder auch einfach
                    nur eine innige Umarmung, ganz nach Deinen Wünschen.
                </p>

                <p>
                    Ob wir dabei bekleidet bleiben oder nackt sind,
                    entscheidest Du.
                </p>

                <p>
                    Mein Angebot für achtsames Kuscheln findet im
                    Sarganserland statt und richtet sich auch an
                    Menschen aus Mels, Sargans, Bad Ragaz und der
                    umliegenden Region.
                </p>

            </main>

        </>
    );
}


export default KuschelnPage;